import { useQuery } from "react-query";
import { getBusLicenseAndPermitByRecordId } from "../../../../actions/CarrierAgreementMgmt/BusinessLicensesAndPermits";

export const useGetBusLicenseAndPermitByRecordId = (recordId) => {
  return useQuery(
    ["GetBusLicenseAndPermitByRecordId", recordId],
    () => getBusLicenseAndPermitByRecordId(recordId),
    { refetchOnWindowFocus: false }
  );
};
